"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _component = _interopRequireDefault(require("@loadable/component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Typography = (0, _component.default)(function () {
  return import("@micado-digital/react-ui/components/Typography");
});

var ReactHeadline01 = function ReactHeadline01(_ref) {
  var className = _ref.className,
      component = _ref.component,
      text = _ref.text,
      variant = _ref.variant,
      variants = _ref.variants,
      TypographyProps = _ref.TypographyProps;
  var headlineVariant = typeof variant === "number" ? "h".concat(variant ? variant + 1 : 1) : variant;
  component = typeof variant === "number" ? headlineVariant : component;
  if (!text) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(Typography, _extends({
    className: (0, _clsx.default)("mco-headline", className),
    component: component,
    dangerouslySetInnerHTML: {
      __html: text
    },
    variant: headlineVariant,
    variants: variants
  }, TypographyProps));
};

ReactHeadline01.propTypes = {
  className: _propTypes.default.string,
  component: _propTypes.default.string,
  text: _propTypes.default.string.isRequired,
  variant: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  variants: _propTypes.default.object,
  TypographyProps: _propTypes.default.object
};
var _default = ReactHeadline01;
exports.default = _default;